import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  background: ${props => props.primaryColor || '#36397A'} 50%;
  position: relative;

  iframe {
    position: absolute;
    width: 600px;
    height: 375px;
    left: 50%;
    top: -30%;
    transform: translate(-50%, -50%);
  }

  @media only screen and (max-width: 950px) {
    align-items: center;
    min-height: 180px;

    iframe {
      top: -10%;
      position: absolute;
      width: 364px;
      height: 279px;
    }
  }
`;

export const Main = styled.div`
  width: 100%;
  display: ${props => (props.actived ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-top: 100px;
  height: 500px;
  position: relative;

  @media only screen and (max-width: 950px) {
    margin-top: 20px;
    height: 350px;
  }
`;
